import { Box, Flex } from '@chakra-ui/react';
import { Routes, Route, Navigate } from 'react-router-dom';

import PrivateContentLayout from '../../Platform/Common/PrivateContentLayout';
import TutorSideBar from '../../Platform/Components/TutorSideBar';
import TutorCalendar from '../../Platform/Tutor/TutorCalendar';
import TutorBatches from '../../Platform/Tutor/TutorBatches';
import TutorUpcomingClasses from '../../Platform/Tutor/TutorUpcomingClasses';
import LessonSummaryViewer from '../../Platform/Tutor/LessonSummaryViewer';
import TutorExams from '../../Platform/Tutor/TutorExams';
import EvaluateExamByTutor from '../../Platform/Tutor/EvaluateExamByTutor';
import B2CAssessorSideBar from '../Components/B2CAssessorSideBar';


const B2CAssessorRouter = () => {


    return (
        <Box >

          {/* Sidebar with fixed width */}
            <B2CAssessorSideBar />
            <PrivateContentLayout>
          {/* Main content area with flexible width */}
          <Box overflowY="auto">
            <Routes>
              <Route path="/" element={<Navigate to="tutor-calendar" />} />
              <Route path="tutor-calendar" element={<TutorCalendar />} />
              <Route path="tutor-batches" element={<TutorBatches />} />
              <Route path="tutor-upcoming-classes" element={<TutorUpcomingClasses />} />
              <Route path="tutor-upcoming-classes/lesson-summary/:plannedClassId" element={<LessonSummaryViewer />} />
              <Route path="tutor-exams" element={<TutorExams />} />
              <Route path="tutor-exams/evaluate-exam-by-tutor/:exam_id" element={<EvaluateExamByTutor />} />
            </Routes>
          </Box>
          </PrivateContentLayout>
      </Box>
    );
  };

export default B2CAssessorRouter;
